import { Box, Typography } from "@mui/material";
import { Product, ProductSizes } from "../../../../../gobalType";
import { ButtonPlant } from "../../../PlantsPage/Plants.style";

type AvailabilitySizeTagProps = {
  product: Product | any;
  size: ProductSizes;
  onClick: (product: Product | any, size: ProductSizes) => void;
  /** Chỉ dùng trên list mobile: bấm tag = chọn size cho Add, không mở chi tiết */
  onSelectAsActive?: (product: Product | any, size: ProductSizes) => void;
  isActive?: boolean;
};

function formatQuantityData(amount: number, thousandsSeparator = ",") {
  const roundedAmount = Math.round(amount * 100) / 100;
  const amountString = roundedAmount.toFixed(2);
  const [integerPart] = amountString.split(".");
  return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
}

export function AvailabilitySizeTag({
  product,
  size,
  onClick,
  onSelectAsActive,
  isActive = false,
}: AvailabilitySizeTagProps) {
  const firstQty = size?.quantity_available?.[0];
  if (!firstQty) return null;

  const quantity = formatQuantityData(firstQty.quantity);
  const label = `${size?.name} - ${quantity}pcs`;

  const handleButtonClick = () => {
    if (onSelectAsActive) {
      onSelectAsActive(product, size);
      return;
    }
    onClick(product, size);
  };

  return (
    <Box sx={{ width: "auto", maxWidth: "100%", minWidth: 0 }}>
      <ButtonPlant
        onClick={handleButtonClick}
        style={{
          backgroundColor: isActive ? "#7fb87e" : "#9ACC99",
          boxShadow: isActive ? "0 0 0 2px #1d4f1f" : undefined,
          paddingLeft: 10,
          paddingRight: 10,
          width: "auto",
          maxWidth: "100%",
          minWidth: 0,
        }}
        className="product-item-size">
        <Typography
          sx={{
            fontSize: { xs: "11px", sm: "12px", md: "13px" },
            marginBottom: 0,
            fontWeight: 600,
            whiteSpace: "nowrap",
            lineHeight: 1.35,
            px: 0.75,
            display: "block",
          }}
          title={label}>
          {label}
        </Typography>
      </ButtonPlant>
    </Box>
  );
}
